import { render, staticRenderFns } from "./BatchFormTemplate.vue?vue&type=template&id=226eb306&scoped=true&"
import script from "./BatchFormTemplate.vue?vue&type=script&lang=ts&"
export * from "./BatchFormTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./BatchFormTemplate.vue?vue&type=style&index=0&id=226eb306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226eb306",
  null
  
)

export default component.exports